import { render, staticRenderFns } from "./media-item.vue?vue&type=template&id=19feb074"
import script from "./media-item.vue?vue&type=script&lang=js"
export * from "./media-item.vue?vue&type=script&lang=js"
import style0 from "./media-item.vue?vue&type=style&index=0&id=19feb074&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports